
class Roles {
    static Admin = 'Admin';
    static User = 'User';
    static Manager = 'Manager';
    static Master = 'Master';
    static Consultant = 'Consultant';
    static System = 'System'
    static PreUser = 'PreUser'
    static Marketing = 'Marketing'
    static Partner = 'Partner'
    static HeadOffice = 'HeadOffice'
    static BranchOffice = 'BranchOffice'
    static Seller = 'Seller'
}

export default Roles;